import React from "react";
import "./HomeArchetype.css";
import gd from "../../images/gift-green.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function HomeArchetype() {
  return (
    <div className="homearche-cont">
      <div className="container">
        <div className="row">
          <div className="homearche-title">
            <h6>HOW PERSONALITY PEEK WORKS</h6>
            <h3>
              Discover your <span>Core-64</span> archetype
            </h3>
            <p>
              Personality Peek is a free personality quiz built around the
              Core-64 system.
              <span>
                It maps your answers across six personality dimensions and
                reveals one of 64 archetypes.
              </span>
            </p>

            <div className="homearche-icons">
              <div>
                <span>
                  <img src={gd} alt="" />
                </span>
                6 Dimensions
              </div>

              <div>
                <span>
                  <img src={gd} alt="" />
                </span>
                64 archetypes
              </div>

              <div>
                <span>
                  <img src={gd} alt="" />
                </span>
                Free test
              </div>
            </div>
          </div>
        </div>

        <div className="row homearche-cards-row ">
          <div className="col-md-4">
            <div
              className="homearche-cards"
              style={{ "--home-ar-bg": "#f0e8f8", "--home-ar-text": "#7f3eda" }}
            >
              <span>1</span>
              <h6>The free personality quiz</h6>
              <p>
                Answer thoughtful questions that map your responses across six
                personality dimensions.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div
              className="homearche-cards"
              style={{ "--home-ar-bg": "#e9eff9", "--home-ar-text": "#4e92a5" }}
            >
              <span>2</span>
              <h6>
                Your six-letter <span>archetype code </span>
              </h6>
              <p>
                You'll receive a unique six-letter code that reflects where you
                naturally lean across six trait pairs.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div
              className="homearche-cards"
              style={{ "--home-ar-bg": "#f0e8f8", "--home-ar-text": "#7f3eda" }}
            >
              <span>3</span>
              <h6>
                Practical growth, <span>not labels</span>
              </h6>
              <p>
                The Core-64 archetypes help you understand your gifts, blind
                spots, and next moves—so you can grow with more clarity and
                confidence.
              </p>
            </div>
          </div>

          <div className="homearche-btn-div">
            <a href="" class="new-commom-btn start-homearche">
              <span>Start My Free Test</span>

              <span class="righ-arr">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </a>

            <a href="" class="new-commom-btn homearche-explore">
              <span>Explore all 64 archetypes</span>

              <span class="righ-arr">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeArchetype;
